import React from 'react';
const causes = [{
  emoji: '🦠',
  label: 'CAUSA 1',
  title: 'EL BIOFILM ACTIVO',
  text: 'El hongo construye una fortaleza protectora. Los medicamentos no pueden penetrarla.'
}, {
  emoji: '🫁',
  label: 'CAUSA 2',
  title: 'EL INTESTINO DAÑADO',
  text: 'El 70% de los casos tiene origen intestinal. El intestino re-infecta la vagina cada mes.'
}, {
  emoji: '🍬',
  label: 'CAUSA 3',
  title: 'LA ALIMENTACIÓN',
  text: 'Cada gramo de azúcar es combustible directo para el hongo que querés eliminar.'
}];
export function TriangleSection() {
  return <section className="w-full px-6 py-16 max-w-2xl mx-auto" data-id="element-243">
      <p className="text-brand-teal text-[11px] font-semibold uppercase tracking-widest mb-3" data-id="element-244">
        Las 3 causas que nadie trata juntas
      </p>
      <h2 className="text-[24px] font-bold text-white mb-8 leading-tight" data-id="element-245">
        Por qué te vuelve una y otra vez
      </h2>

      <div className="flex flex-col gap-4 mb-8" data-id="element-246">
        {causes.map((cause, i) => <div key={i} className="bg-white/[0.04] rounded-2xl p-5 border border-white/[0.08]" data-id="element-247">
            <p className="text-brand-muted text-[11px] font-semibold uppercase tracking-wider mb-1" data-id="element-248">
              {cause.emoji} {cause.label}
            </p>
            <p className="text-white font-bold text-base mb-2" data-id="element-249">{cause.title}</p>
            <p className="text-[15px] text-brand-muted leading-relaxed" data-id="element-250">
              {cause.text}
            </p>
          </div>)}
      </div>

      <p className="text-[15px] text-white text-center font-semibold" data-id="element-251">
        El <span className="text-brand-teal" data-id="element-252">Método pH-ZERO</span> ataca las 3
        causas al mismo tiempo.
      </p>
    </section>;
}